<mat-form-field *ngIf="!waiting">
  <mat-select [placeholder]="('shared.filters.currency.select_your_money' | translate )" [(value)]="selected">
    <mat-option *ngFor="let money of currencies" [value]="money.code" (click)="setCurrency(money)">{{money.code | uppercase}}</mat-option>
  </mat-select>
</mat-form-field>


